import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { openOverlayPage } from 'helpers/web_to_client'
import {
    CLAN_LANDING,
    WGCWX_SHOP,
    WGCWX_SHOP_REWARDS,
    WGCWX_BATTLE_SCHEDULE,
    WGCWX_LEADERBOARDS } from 'urls'
import classNames from 'classnames'
import { KEY_CODES } from 'constants'

import { Back, Processing } from 'react-wot-bootstrap'
import { BACK_CAPTIONS } from 'components/Back/constants'
import InfoButton from 'components/InfoButton/InfoButton'
import MainMenu from 'containers/MainMenu/MainMenu'

import { requestCraftMachineInfo } from 'state/actions/craft_machine'
import { requestGlobalMapInfo } from 'state/actions/global_map'
import { fetchClanInfo } from 'state/actions/wgcwx_shop'
import { playExitGlobalMapSound } from 'state/actions/sounds'
import WGCWXConfirmation from 'components/WGCWXConfirmation/WGCWXConfirmation'

import { ABOUT } from './translations'
import { AFFIRMATIVE } from '../WGCWXShop/translations'
import ERRORS, { ERROR_CODES } from './errors'
import styles from './WGCWXWrapper.scss'

export class WGCWXWrapper extends React.Component {
    static propTypes = {
        loaded: PropTypes.bool.isRequired,
        // eslint-disable-next-line react/no-unused-prop-types
        isGlobalMapInfoLoaded: PropTypes.bool.isRequired,
        contentUrl: PropTypes.string,
        isMenuAvailable: PropTypes.bool.isRequired,
        isEscHandlerDisabled: PropTypes.bool.isRequired,

        onComponentDidMount: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        playExitGlobalMapSound: PropTypes.func.isRequired,
        location: PropTypes.string,
        error: PropTypes.bool,
    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown)
        this.props.onComponentDidMount(this.props)
        window.onBeforeUnloadHandlers.playGlobalMapSoundsOnExit = () => {
            this.props.playExitGlobalMapSound()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown)
        this.props.playExitGlobalMapSound()
        delete window.onBeforeUnloadHandlers.playGlobalMapSoundsOnExit
    }

    openContentPage = () => {
        if (this.props.contentUrl) {
            openOverlayPage(this.props.contentUrl)
        }
    }

    onKeyDown = event => {
        const { close, isEscHandlerDisabled } = this.props
        if (!isEscHandlerDisabled && event.keyCode === KEY_CODES.ESCAPE) {
            close()
        }
    }

    renderError = () => {
        const { close, location } = this.props

        const errorData = (() => {
            switch (location) {
            case WGCWX_SHOP:
                return ERRORS[ERROR_CODES.PRODUCTS_UNKNOWN_ERROR]
            case WGCWX_SHOP_REWARDS:
                return ERRORS[ERROR_CODES.REWARDS_UNKNOWN_ERROR]
            case WGCWX_BATTLE_SCHEDULE:
                return ERRORS[ERROR_CODES.BATTLES_UNKNOWN_ERROR]
            case WGCWX_LEADERBOARDS:
                return ERRORS[ERROR_CODES.LEADERBOARDS_UNKNOWN_ERROR]
            }
        })()

        const { title, description } = errorData
        const errorClassNames = classNames(styles.base, styles.base__overlayOpened)

        return (
            <div className={errorClassNames}>
                <div className={styles.background} />
                <WGCWXConfirmation
                    messageType="error"
                    title={title}
                    description={description}
                    buttonsOptions={[
                        {
                            caption: AFFIRMATIVE,
                            callback: () => close(),
                        },
                    ]}
                    onClose={() => close()}
                />
            </div>
        )
    }

    render() {
        const {
            loaded,
            isMenuAvailable,
            contentUrl,
            close,
            children,
            error,
        } = this.props

        if (error) {
            return this.renderError()
        }

        if (!loaded) return <Processing type="fullscreen" isVisible />

        return (
            <div>
                {contentUrl && (
                    <div className={styles.about}>
                        <InfoButton
                            caption={ABOUT}
                            onClick={this.openContentPage}
                        />
                    </div>
                )}
                <div className={styles.close}>
                    <Back
                        side='right'
                        type='close'
                        caption={BACK_CAPTIONS.close}
                        onClick={close}
                    />
                </div>
                {isMenuAvailable && <MainMenu />}
                {children}
            </div>
        )
    }
}

export const stateToProps = (state) => ({
    craftMachine,
    globalMap,
    wgcwxShop,
    wgcwxClanInfo,
}) => {
    const loaded = (globalMap.loaded && craftMachine.loaded && wgcwxClanInfo.loaded)

    const menuItemsArr = [
        craftMachine.is_craft_machine_enabled,
        craftMachine.is_enhancements_enabled,
        globalMap.personal_bonuses_enabled,
        globalMap.event_rewards_enabled,
        globalMap.battle_schedule_enabled,
        globalMap.leaderboards_enabled,
    ]
    const isMenuAvailable = menuItemsArr.filter(item => item).length > 1

    const isEscHandlerDisabled = wgcwxShop.innerPageOpened

    return {
        loaded,
        isGlobalMapInfoLoaded: globalMap.loaded,
        contentUrl: craftMachine.webbrg_content_url,
        isMenuAvailable,
        isEscHandlerDisabled,
        error: globalMap.error,
        location: state.routing.locationBeforeTransitions.pathname,
    }
}

const dispatchToProps = (dispatch) => ({
    onComponentDidMount: (props) => {
        if (!props.isGlobalMapInfoLoaded) {
            dispatch(requestGlobalMapInfo())
        }

        dispatch(requestCraftMachineInfo())
        dispatch(fetchClanInfo())
    },
    close: () => dispatch(push(CLAN_LANDING)),
    playExitGlobalMapSound: () => dispatch(playExitGlobalMapSound()),
})

export default connect(stateToProps, dispatchToProps)(WGCWXWrapper)



// WEBPACK FOOTER //
// ./containers/WGCWXWrapper/WGCWXWrapper.jsx